import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useMyTasks } from '../../api/taskQueries.ts';
import { useSeen } from '../../tasks/seen.ts';
import { TaskRow } from './TaskRow.tsx';
import { TaskCard } from './TaskCard.tsx';

/** How many open tasks the dashboard shows: the rest are on My tasks. */
export const DASHBOARD_TASKS = 12;

/**
 * The dashboard's "Your tasks" (147): the first twelve OPEN tasks in the server's group order (done this week stays on
 * My tasks), each opening the task card. Exactly the twelve drawn are reported seen (ruling 17; Code 0: the dashboard's
 * first twelve count). Actions are recorded from a department section of the client page (A-#144), not here.
 */
export function DashboardTasks() {
  const mine = useMyTasks();
  const [open, setOpen] = useState<string | null>(null);
  const openTasks = (mine.data?.groups ?? []).filter((g) => g.key !== 'done_this_week').flatMap((g) => g.tasks);
  const shown = openTasks.slice(0, DASHBOARD_TASKS);
  useSeen(mine.data ? shown : undefined);
  return (
    <section className="panel">
      <header className="panel-bar">
        <h2>Your tasks</h2>
        <Link to="/tasks" className="inline-flex min-h-[44px] items-center text-on-brand underline normal-case tracking-normal">All tasks</Link>
      </header>
      {!mine.data ? (
        <p className="px-4 py-3 text-neutral-700">{mine.error ? 'Your tasks could not be loaded.' : 'Loading…'}</p>
      ) : shown.length === 0 ? (
        <p className="px-4 py-3 text-neutral-700">No open tasks are assigned to you.</p>
      ) : (
        <ol className="divide-y divide-neutral-200 pb-2">
          {shown.map((t) => <TaskRow key={t.id} task={t} today={mine.data!.today} onOpen={setOpen} />)}
        </ol>
      )}
      {openTasks.length > shown.length && (
        <p className="px-4 pb-3 text-sm text-neutral-700">{openTasks.length - shown.length} more in My tasks.</p>
      )}
      {open && <TaskCard taskId={open} onClose={() => setOpen(null)} />}
    </section>
  );
}
